import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const timelineData = [{
  year: "Haftung",
  title: "Haftungsausschluss",
  description: "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/legal_disclaimer_document.png"
}, {
  year: "Links",
  title: "Haftung für Links",
  description: "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/external_links_policy.png"
}, {
  year: "Schutz",
  title: "Urheberrecht",
  description: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/copyright_protection_seal.png"
}, {
  year: "Daten",
  title: "Datenschutzhinweis",
  description: "Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642178/img/data_privacy_security.png"
}];
export default function OnsVerhaal() {
  return;
}